const C = {};

C.BASE_URL = process.env.REACT_APP_BASE_URL;
C.URL_LANDING = process.env.REACT_APP_URL_LANDING;


C.CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
C.API_KEY = process.env.REACT_APP_API_KEY;
C.URL_LOGIN = `https://2mw.auth.us-east-2.amazoncognito.com/login?client_id=${C.CLIENT_ID}&response_type=code&scope=openid&redirect_uri=${encodeURIComponent(process.env.REACT_APP_URL_LANDING)}`;
C.API_IDTOKEN_VERIFICATION = process.env.REACT_APP_API_IDTOKEN_VERIFICATION;
C.API_CONFIG = process.env.REACT_APP_API_CONFIG;
C.API_PROFILE_UPDATE = process.env.REACT_APP_API_PROFILE_UPDATE;
C.API_SIGN_UP = process.env.REACT_APP_API_SIGN_UP;
C.API_LOGIN = process.env.REACT_APP_API_LOGIN;
C.API_RESET_PASSWORD = process.env.REACT_APP_API_RESET_PASSWORD;
C.USER_POOL_ID = process.env.REACT_APP_USER_POOL_ID;
C.REGION = 'us-east-2';
C.IDENTITY_POOL_ID = `${C.REGION}:${process.env.REACT_APP_IDENTITY_POOL_ID}`;


C.USER_STATE = {};
C.USER_STATE.LOADING = 'LOADING';
C.USER_STATE.LOGGED_OUT = 'LOGGED_OUT';
C.USER_STATE.SIGN_UP = 'SIGN_UP';
C.USER_STATE.ERROR = 'ERROR';
C.USER_STATE.UNCONFIRMED = 'UNCONFIRMED';
C.USER_STATE.INCOMPLETE = 'INCOMPLETE';
C.USER_STATE.COMPLETE = 'COMPLETE';
C.USER_STATE.CONFIRMED = 'CONFIRMED';
C.USER_STATE.SUBSCRIBED = 'SUBSCRIBED';
C.USER_STATE.RESET_PASSWORD = 'RESET_PASSWORD';
C.USER_STATE.RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';

C.RSPCODE = {};
C.RSPCODE.ERROR = 'ERROR';


export default C;